export default "__VITE_ASSET__ClFbLd4A__"